import React from "react";
import { motion } from "framer-motion";

const Social = () => {
  const options = {
    initial: {
      x: "-100%",
      opacity: 0,
    },
    whileInView: {
      x: 0,
      opacity: 1,
    },
  };
  return (
    <motion.div {...options}>
      <div className="home__social">
        <a
          href="https://github.com/arghyadeb11"
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="uil uil-github"></i>
        </a>
        <a
          href="https://wa.me/+918902429351"
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="uil uil-whatsapp"></i>
        </a>
      </div>
    </motion.div>
  );
};

export default Social;
